const percentage = (value: number, total: number): number => (value * 100) / total;

export default percentage;
